/*

      =========================================================
      * XGuard
      =========================================================
      
      * Product Page: https://www.nelx.net/xguard
      * Copyright 2024 NELX (https://www.nelx.net/)
      
      =========================================================
*/

import React from "react";
import { Flex } from "@chakra-ui/react";

export default function GradientBorder(props) {
  const { variant, children, ...rest } = props;
  return (
    <Flex
      p='2px'
      justify='center'
      align='center'
      bg='radial-gradient(69.43% 69.43% at 50% 50%, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0) 100%),
      radial-gradient(60% 51.57% at 50% 50%, #8b5cf6 0%, rgba(139, 92, 246, 0) 100%),
      radial-gradient(54.8% 53% at 50% 50%, #6d28d9 0%, rgba(109, 40, 217, 0) 100%)'
      transition="all 0.3s ease-in-out"
      _hover={{
        bg: 'radial-gradient(69.43% 69.43% at 50% 50%, rgba(255, 255, 255, 0.9) 0%, rgba(255, 255, 255, 0) 100%), radial-gradient(60% 51.57% at 50% 50%, #9f75ff 0%, rgba(159, 117, 255, 0) 100%), radial-gradient(54.8% 53% at 50% 50%, #7c3aed 0%, rgba(124, 58, 237, 0) 100%)',
        boxShadow: '0 0 30px rgba(139, 92, 246, 0.3)',
      }}
      {...rest}>
      {children}
    </Flex>
  );
}
